import { useState } from "react";
import { CheckCircle2, XCircle, AlertTriangle } from "lucide-react";
import { usePortal } from "@/pages/admin/PortalLayout";

const ResultIcon = ({ r }) => (r === "ok" ? <span className="inline-flex items-center gap-1 text-[#0F5132] dark:text-emerald-400"><CheckCircle2 size={13} /> ok</span>
  : r === "denied" ? <span className="inline-flex items-center gap-1 text-[#842029] dark:text-red-400"><XCircle size={13} /> denied</span>
    : <span className="inline-flex items-center gap-1 text-[#664D03]"><AlertTriangle size={13} /> {r}</span>);

export default function PortalAudit() {
  const [filter, setFilter] = useState("");
  const [items] = usePortal(`/portal/audit?limit=300${filter ? `&action=${encodeURIComponent(filter)}` : ""}`);
  return (
    <div className="space-y-5" data-testid="portal-audit">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><h1 className="text-2xl font-bold md:text-3xl">Audit log</h1><p className="text-sm text-muted-foreground">Logins, OTP results, admin actions, exports, imports and payments.</p></div>
        <input data-testid="audit-filter-input" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter action (e.g. otp)" className="h-10 rounded-xl border bg-card px-3 text-sm" />
      </div>
      <div className="overflow-x-auto rounded-2xl border bg-card shadow-sm">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-muted text-left text-xs uppercase tracking-wider text-muted-foreground"><tr><th className="p-3">Time</th><th className="p-3">Actor</th><th className="p-3">Action</th><th className="p-3">Result</th><th className="p-3">Detail</th></tr></thead>
          <tbody>
            {(items || []).map((a) => (
              <tr key={a.id} className="border-t align-top">
                <td className="whitespace-nowrap p-3 text-xs">{new Date(a.at).toLocaleString()}</td>
                <td className="p-3 text-xs">{a.actor}</td>
                <td className="p-3 font-mono text-xs">{a.action}</td>
                <td className="p-3 text-xs font-semibold"><ResultIcon r={a.result} /></td>
                <td className="max-w-xs truncate p-3 text-[11px] text-muted-foreground" title={JSON.stringify(a.detail)}>{a.detail ? JSON.stringify(a.detail) : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
